import { useEffect } from 'react'

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

const PIXEL_ID = '817879127936181'

export const useMetaPixel = () => {
  useEffect(() => {
    // Initialize Pixel
    if (typeof window !== 'undefined') {
      !(function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
        if (f.fbq) return
        n = f.fbq = function () {
          n.callMethod
            ? n.callMethod.apply(n, arguments)
            : n.queue.push(arguments)
        }
        if (!f._fbq) f._fbq = n
        n.push = n
        n.loaded = !0
        n.version = '2.0'
        n.queue = []
        t = b.createElement(e)
        t.async = !0
        t.src = v
        s = b.getElementsByTagName(e)[0]
        // Safety check: if no script tags exist, append to head instead
        if (s && s.parentNode) {
          s.parentNode.insertBefore(t, s)
        } else {
          b.head.appendChild(t)
        }
      })(
        window,
        document,
        'script',
        'https://connect.facebook.net/en_US/fbevents.js',
      )

      window.fbq('init', PIXEL_ID)
      window.fbq('track', 'PageView')
    }
  }, [])

  const trackEvent = (eventName: string, data?: any) => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', eventName, data)
    }
  }

  return { trackEvent }
}
